import React from 'react';
import { CheckCircle } from 'lucide-react';

const benefits = [
  'Free, no-obligation inspection',
  'Same-day emergency response',
  'Competitive pricing & financing',
  'Fully licensed & insured'
];

export const WhyBookWithUs = () => {
  return (
    <div className="bg-primary/10 border-2 border-primary/20 rounded-xl p-6">
      <div className="flex items-center space-x-3 mb-3">
        <CheckCircle className="w-6 h-6 text-primary" />
        <h4 className="font-bold text-gray-900">Why Book With Us?</h4>
      </div>
      <ul className="space-y-2 text-sm text-gray-700">
        {benefits.map((benefit, index) => (
          <li key={index} className="flex items-center space-x-2">
            <span className="w-1.5 h-1.5 bg-primary rounded-full"></span>
            <span>{benefit}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
